export const SourceRequestStatusInfo = "requeststatusinfos";

export const TitleRequestStatusInfo = {
  list: "Request Status Info List",
  create: "Create Request Status Info",
  edit: "Edit Request Status Info",
};
